<template>
  <div class="list-item template-item">
    <v-list-item-avatar tile>
      <v-icon>mdi-briefcase-outline</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description">
          <div class="d-flex" :class="{ 'flex-column': isMobile }">
            <span class="font-weight-bold">{{ bookingTemplate.jobTitle }}</span>
          </div>
          <div class="status-wrapper">
            <span class="mr-1 mt-1 secondary-text">{{
              bookingTemplate.functionName
            }}</span>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
export default {
  name: "RoleListItem",
  props: {
    bookingTemplate: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scope></style>
